import { type ComponentProps } from 'react'
import styled, { css } from 'styled-components'

import { type TabPills } from '@components/common'
import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  gap: var(--space-250);
  flex-wrap: wrap;
`

export const Tab = styled.button<{
  $active?: boolean
  $appearance: ComponentProps<typeof TabPills>['appearance']
  $size: ComponentProps<typeof TabPills>['size']
}>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  border-radius: var(--radius-brand);
  text-align: center;
  font-weight: var(--font-weight-medium);
  transition: all var(--motion-duration-100) var(--motion-ease-in-out);

  ${({ $size }) =>
    $size === 'small' &&
    css`
      padding: var(--space-100) var(--space-150);
      font-size: var(--font-size-200);
      line-height: var(--font-line-height-200);
      letter-spacing: var(--font-letter-spacing-looser);
    `};

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      padding: var(--space-150) var(--space-250);
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-300);
      letter-spacing: var(--font-letter-spacing-loose);
    `};

  ${({ $size }) =>
    $size === 'large' &&
    css`
      padding: var(--space-200) var(--space-350);
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
      letter-spacing: var(--font-letter-spacing-normal);
    `};

  ${({ $appearance, $active }) =>
    $appearance === 'primary' &&
    css`
      background: transparent;
      color: var(--text-secondary);

      &:hover {
        background: var(--bg-transparent);
        color: var(--text-primary);
      }

      ${$active &&
      css`
        &,
        &:hover {
          background: var(--bg-transparent);
          color: var(--text-primary);
        }
      `};
    `};

  ${({ $appearance, $active }) =>
    $appearance === 'secondary' &&
    css`
      background: ${Colors.GS800};
      color: ${Colors.GS550};

      &:hover {
        background: ${Colors.GS700};
      }

      ${$active &&
      css`
        &,
        &:hover {
          background: ${Colors.GS100};
          color: ${Colors.GS1000};
        }
      `};
    `};
`
